import { ContainerSpec, ContainerFitResult, PalletSpec } from '@freight-cbm/shared-types';

export function calcContainerFit(
  totalCBM: number,
  grossWeightKg: number,
  specs: ContainerSpec[],
): ContainerFitResult[] {
  if (totalCBM <= 0 && grossWeightKg <= 0) {
    return specs.map((spec) => ({
      containerType: spec.type,
      containerCount: 0,
      volumeUtilization: 0,
      weightUtilization: 0,
      usedCBM: 0,
      availableCBM: spec.volumeCBM,
    }));
  }

  return specs.map((spec) => {
    const volumeUtilization = Math.min((totalCBM / spec.volumeCBM) * 100, 100);
    const weightUtilization = Math.min((grossWeightKg / spec.maxPayloadKg) * 100, 100);
    const containerCount = Math.ceil(
      Math.max(totalCBM / spec.volumeCBM, grossWeightKg / spec.maxPayloadKg)
    );
    const usedCBM = totalCBM;
    const availableCBM = containerCount * spec.volumeCBM - totalCBM;

    return {
      containerType: spec.type,
      containerCount,
      volumeUtilization,
      weightUtilization,
      usedCBM,
      availableCBM,
    };
  });
}

export function calcPalletsPerContainer(
  container: ContainerSpec,
  pallet: PalletSpec,
  loadHeight?: number,
): { perFloor: number; tiers: number; totalPalletsPerContainer: number } {
  const orientation1 =
    Math.floor(container.internalLength / pallet.length) *
    Math.floor(container.internalWidth / pallet.width);
  const orientation2 =
    Math.floor(container.internalLength / pallet.width) *
    Math.floor(container.internalWidth / pallet.length);
  const perFloor = Math.max(orientation1, orientation2);

  const usableHeight = Math.min(
    loadHeight ?? pallet.maxStackHeight,
    container.internalHeight,
  );
  const tiers = Math.max(1, Math.floor(usableHeight / pallet.maxStackHeight));
  const totalPalletsPerContainer = perFloor * tiers;

  return { perFloor, tiers, totalPalletsPerContainer };
}
